module.exports = __webpack_public_path__ + "img/火龙果7.898c6fcc.png";